import Swiper from "swiper";
import { A11y, Keyboard, Navigation } from "swiper/modules";
import type { SwiperOptions } from "swiper/types";
// @ts-ignore
import "swiper/css/bundle";

const mobileMQ = window.matchMedia("(max-width: 768px)");

export class Carousel {
  private element: HTMLElement;
  private mobileOnly: boolean = false;
  private swiper: Swiper | null = null;

  constructor(element: HTMLElement) {
    if (!!element) {
      this.element = element;
      this.mobileOnly = element.dataset.mobileOnly === "true";
      this.init();
    }
  }

  private init() {
    if (this.mobileOnly) {
      this.handleResize();
      this.handleMobileOnly();
    } else {
      this.initializeSwiper();
    }
  }

  private handleResize() {
    const resize = () => {
      this.handleMobileOnly();
    };
    mobileMQ.addEventListener("change", resize);
    if (!mobileMQ.matches) {
      resize();
    }
  }

  private initializeSwiper() {
    const swiperParams: SwiperOptions = {
      slidesPerView: 1,
      autoHeight: true,
      spaceBetween: 50,
      loop: true,
      modules: [Navigation, A11y, Keyboard],
      a11y: {
        enabled: true,
        nextSlideMessage: "Next",
        prevSlideMessage: "Previous",
      },
      keyboard: {
        enabled: true,
      },
      navigation: {
        nextEl: ".swiper__prev-next--next",
        prevEl: ".swiper__prev-next--prev",
      },
    };

    this.swiper = new Swiper(this.element, swiperParams);

    const bullets = this.element.querySelectorAll(
      ".swiper-pagination-bullet",
    ) as NodeListOf<HTMLButtonElement>;
    bullets.forEach((bullet, index) => {
      bullet.addEventListener("click", () => {
        this.swiper?.slideToLoop(index);
      });
    });
  }

  private handleMobileOnly() {
    if (mobileMQ.matches) {
      if (!this.swiper) {
        this.initializeSwiper();
      }
      this.element.classList.remove("carousel--inactive");
    } else {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
      this.element.classList.add("carousel--inactive");
    }
  }
}

export default function carouselInit() {
  const carousel = document.querySelectorAll(
    ".carousel",
  ) as NodeListOf<HTMLElement>;
  for (let i = 0; i < carousel.length; i++) {
    new Carousel(carousel[i]);
  }
}
